import React from "react";
import { TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import useResponsive from "core/hooks/useResponsive";

const MyAccountLayoutStyle = {
  style: {
    backgroundColor: variables.grey5,
    display: "flex",
  },
  topSectionStyle: {
    paddingTop: variables.paddingMediumLarge,
    paddingLeft: variables.paddingMedium,
    paddingBottom: variables.paddingMedium2,
  },
  linkStyle: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  backArrow: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    marginRight: variables.marginMediumSmall,
  },
  bottomSectionStyle: {
    backgroundColor: variables.bodyBg,
    flex: 1,
    width: variables.myAccountContainerWidth,
    margin: `0 ${variables.marginAuto}`,
    border: `1px solid ${variables.grey4}`,
    marginBottom: variables.marginMedium,
    display: variables.dFlex,
    alignSelf: variables.alignCenter,
    justifyContent: variables.alignCenter,
    overflow: variables.overflowInitial,
  },
};
export default function MyAccountLayout({ topSection, bottomSection }) {
  const responsive = useResponsive();

  return (
    <TwoRow
      style={MyAccountLayoutStyle.style}
      topSection={topSection}
      topSectionStyle={MyAccountLayoutStyle.topSectionStyle}
      bottomSection={bottomSection}
      bottomSectionStyle={{
        ...MyAccountLayoutStyle.bottomSectionStyle,
        ...(!responsive.isMd && {
          width: variables.unset,
          maxWidth: variables.myAccountContainerWidth,
        }),
      }}
    />
  );
}
